var render = function render(){var _vm=this,_c=_vm._self._c;return _c('classroom-schedule-detail',{attrs:{"schedule":_vm.schedule.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }